<template>
  <div v-show="!hide">
    <b-row>
      <b-col>
        <b-form-input
          size="sm"
          v-model="textFilter"
          debounce="250"
          placeholder="Search..."
          @input="currentPage = 1"
        ></b-form-input>
      </b-col>

      <b-col>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="main-table"
          align="right"
          size="sm"
        ></b-pagination>
      </b-col>
    </b-row>

    <b-table
      class="search-table-bordeaux search-table"
      id="main-table"
      sort-icon-left
      :filter="textFilter"
      :items="results.hits"
      :fields="tableFields"
      :per-page="perPage"
      :current-page="currentPage"
      primary-key="_id"
      @row-clicked="onRowClicked"
    >
      <template #cell(expander)="data">
        <svg
          class="bi"
          width="1rem"
          height="1rem"
          fill="currentColor"
          v-if="!data.item._showDetails"
        >
          <use
            xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#chevron-bar-expand"
          />
        </svg>

        <svg class="bi" width="1rem" height="1rem" fill="currentColor" v-else>
          <use
            xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#chevron-bar-contract"
          />
        </svg>
      </template>

      <template #cell(mobilename)="data">
        <div class="mb-1 mb-md-0">
          {{
            data.item._source.ItemDescription[0]
              .replace(data.item._source.CaseSize, "")
              .replace("()", "")
          }}
        </div>

        <div
          v-if="$options.filters.resultPrice(data.item) > 0"
          class="d-md-none type-body-small-bold"
        >
          {{ data.item | resultPrice | currency }} per
          {{ data.item | resultPackage }}
        </div>
        <div
          v-else-if="data.item._source.RangeFrom && data.item._source.RangeTo"
          class="d-md-none type-body-small-bold"
        >
          Est. {{ data.item._source.RangeFrom | currency }} -
          {{ data.item._source.RangeTo | currency }} per
          {{ data.item | resultPackage }}
        </div>
      </template>

      <template slot="row-details" slot-scope="data">
        <ep-table-details :result="data.item"></ep-table-details>
      </template>
    </b-table>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="main-table"
      align="center"
      class="mt-2"
    ></b-pagination>
  </div>
</template>


<script>
import Vue from "vue";
import { BTable } from "bootstrap-vue";

import EpTableDetails from "@/components/EPTableDetails";

export default {
  components: { BTable, EpTableDetails },
  data() {
    return {
      textFilter: "",
      currentPage: 1,
      perPage: 40,
      tableFields: [
        {
          key: "expander",
          label: "",
          formatter() {
            return "";
          },
        },
        {
          key: "_source.SubRegion[0]",
          sortable: true,
          tdClass: ["d-none", "d-md-table-cell"],
          thClass: ["d-none", "d-md-table-cell"],
          label: "Appellation",
        },
        {
          key: "_source.ItemDescription[0]",
          sortable: true,
          label: "Wine Name",
          tdClass: ["d-none", "d-md-table-cell"],
          thClass: ["d-none", "d-md-table-cell"],
          formatter(value, key, item) {
            return value.replace(item._source.CaseSize, "").replace("()", "");
          },
        },
        {
          key: "mobilename",
          sortable: true,
          label: "Wine Name",
          tdClass: ["d-md-none"],
          thClass: ["d-md-none"],
          sortByFormatted(value, key, item) {
            return item._source.ItemDescription[0];
          },
          formatter() {
            return "";
          },
        },
        {
          key: "_source.CaseSize",
          sortable: true,
          tdClass: ["d-none", "d-md-table-cell"],
          thClass: ["d-none", "d-md-table-cell"],
          sortByFormatted(value, key, item) {
            return item._source.PackVolume;
          },
          label: "Case Size",
        },
        {
          key: "price",
          sortable: true,
          label: "Price",
          tdClass: ["d-none", "d-md-table-cell"],
          thClass: ["d-none", "d-md-table-cell"],
          sortByFormatted(value, key, item) {
            if (Vue.options.filters.resultPrice(item) > 0) {
              return Vue.options.filters.resultPrice(item);
            } else if (item._source.RangeFrom && item._source.RangeTo) {
              return item._source.RangeFrom;
            } else {
              return 9999999;
            }
          },
          formatter(value, key, item) {
            if (Vue.options.filters.resultPrice(item) > 0) {
              return Vue.options.filters.currency(
                Vue.options.filters.resultPrice(item)
              );
            } else if (item._source.RangeFrom && item._source.RangeTo) {
              return (
                Vue.options.filters.currency(item._source.RangeFrom) +
                " - " +
                Vue.options.filters.currency(item._source.RangeTo)
              );
            } else {
              return "TBA";
            }
          },
        },
        {
          key: "_source.TastingScore",
          sortable: false,
          label: "Score",
          tdClass: ["d-none", "d-md-table-cell"],
          thClass: ["d-none", "d-md-table-cell"],
        },
        {
          key: "status",
          sortable: false,
          label: "",
          tdClass: ["no-wrap"],
          sortByFormatted: true,
          formatter(value, key, item) {
            if (Vue.options.filters.resultPrice(item) < 1) {
              return "";
            } else if (item._source.StockStatus === "Pre-Order") {
              return "Pre-Order";
            } else if (item._source.StockStatus === "Apply") {
              return "Apply";
            } else if (item._source.StatusLabels.Released === false) {
              return "TBA";
            } else if (item._source.StockLevel > 0) {
              return "Available";
            } else {
              return "Sold Out";
            }
          },
        },
      ],
    };
  },
  computed: {
    rows() {
      return this.results.hits.length;
    },
  },
  methods: {
    onRowClicked(item) {
      this.$set(item, "_showDetails", !item._showDetails);
    },
  },
  props: {
    results: Object,
    hide: {
      type: Boolean,
      default: false,
    },
  },
};
</script>